import axios, { AxiosResponse } from 'axios';
import authHeader from '@/services/auth-header';
import { SALES_CATALOG_ENDPOINT } from '@/constants/endpoints';
import ServiceCatalogItemDTO from '@/dto/sales/catalog/ServiceCatalogItemDTO';

export default new class ServiceCatalogService {
    public getCatalog(): Promise<AxiosResponse<Array<ServiceCatalogItemDTO>>> {
        return axios.get<Array<ServiceCatalogItemDTO>>(SALES_CATALOG_ENDPOINT, { headers: authHeader() });
    }
}
